export enum SmartContentType {
  notes = 'notes',
  paragraphs = 'paragraphs',
}
